import api from './api';

export const getListGrossProfit = (params) => {
  return api().get('/gross-profit-report', { params });
};
export const getChartGrossProfit = (params) => {
  return api().get('/gross-profit-report/chart', { params });
};
export const getWigetGrossProfit = (params) => {
  return api().get('/gross-profit-report/wiget', { params });
};

export const exportExcelGrossProfit = (params) => {
  const header = { responseType: 'blob' };
  return api().post('/gross-profit-report' + '/export-excel', params, header);
};
